import React from "react"
import Helmet from "react-helmet"
import Layout from "@/components/layout"
import Modal from "@/components/popup2/popup"
import JanowoTwoVisual from "@/components/estates/janowotwo/janowoTwoVisual"
import EstateDisclaimer from "@/components/estates/estateDisclaimer"
import OJP3Header from "@/components/estates/ojp3/OJP3Header"
import OJP3Description from "@/components/estates/ojp3/OJP3Description"
import OJP3Localization from "@/components/estates/ojp3/OJP3localization"
import EstateModalForm from "@/components/estates/EstateModalForm"
import EstatePlan from "@/components/estates/estatePlan"
import planImage from "@/images/z-20/mapaOJPIII.png"
import OJP3Visual from "@/components/estates/ojp3/OJP3Visual"
import SearchOjp3 from "@/components/search/searchOJP3"
import list from "@/flats/flatList/OJP3Array"
import EstateHeader from "@/components/estates/estateHeader"
import { logs } from "@/data/diary/buildingLogsOJP3"
import LogBuilding from "@/components/estates/logBuilding"
import { Container, Row, Col } from "react-bootstrap"

import wizImage0 from "@/images/z-26/ojp3-vizki/5_poprawki4_papa.jpg"
import imageLarge from "@/images/z-20/Janowo_Park_III_ujecie_02.jpg"
import wiz_u3 from "@/images/z-20/Janowo_Park_III_ujecie_03.jpg"
import wiz_u4 from "@/images/z-20/Janowo_Park_III_ujecie_04.jpg"
// import wiz_u5 from "@/images/z-20/Janowo_Park_III_ujecie_05.jpg"
import wiz_u6 from "@/images/z-26/ojp3-vizki/6_poprawki2_papa.jpg"

import OJP3Catalog from "@/components/estates/ojp3/OJP3Catalog"
import EstateFlatInfo from "@/components/estates/estateFlatInfo"
// import wiz_u6 from "@/images/z-20/Janowo_Park_III_ujecie_06.jpg"

function Janowo3({ location }) {
  const scrollDestination =
    location && location.state && location.state.position

  // const soldList = list
  //   .filter(a => !!a[13])
  //   .sort((a, b) => a["0"].localeCompare(b["0"]))
  // const freeList = list
  //   .filter(a => !a[13])
  //   .sort((a, b) => a["0"].localeCompare(b["0"]))
  // const sortedList = [...freeList, ...soldList]
  const sortedList = list.sort((a, b) => a.order - b.order)

  return (
    <>
      <Helmet>
        <title>WILLBUD | Osiedle Janowo Park III</title>
      </Helmet>
      <Layout>
        <EstateHeader
          title={`Osiedle Janowo Park III`}
          place={"RUMIA, UL. BŁOŃ JANOWSKICH"}
          // price={8550}
          promo={"NOWE ETAPY B I C JUŻ W SPRZEDAŻY - ZAPOZNAJ SIĘ Z KOLEJNYMI LOKALAMI"}
          inProgress
        />

        <JanowoTwoVisual
          slides={[wizImage0, imageLarge, wiz_u3, wiz_u4]}
          alt={`Janowo Park 3 Wizualizacja`}
        />
        <OJP3Header scrollDestination={scrollDestination} />
        <OJP3Description />
        <OJP3Catalog />

        <OJP3Visual />
        <SearchOjp3 list={sortedList} estate="ojp3" />
        <Container className="no-padding">
          <Row>
            <Col lg={6} md={12}>
              <p>
                Cena miejsca postojowego naziemnego: 15 999 zł brutto
              </p>
              <p>
                Cena miejsca postojowego w hali garażowej: 29 999 zł brutto
              </p>
              <p>
                Cena 1m2 komórki lokatorskiej: 4 999 zł brutto
              </p>
              <EstateFlatInfo >
                <p>
                  Niniejszy cennik obowiązuje od dnia 20.02.2026 r.
                </p>
              </EstateFlatInfo>

            </Col>
            <Col lg={1} md={12}></Col>
            <Col lg={5} md={12}>
              <p><strong>Historia cen</strong></p>
              <p className={"price-info"}>
                <a href="/assets/files/ojp3/HISTORIA CEN OD DNIA 31.12.2025 DO DNIA 18.01.2026_OSIEDLE JANOWO PARK III.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 31.12.2025 DO DNIA 18.01.2026
                  </span>
                </a>
                <a href="/assets/files/ojp3/HISTORIA CEN OD DNIA 13.10.2025 DO DNIA 30.12.2025_OSIEDLE JANOWO PARK III.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 13.10.2025 DO DNIA 30.12.2025
                  </span>
                </a>
                <a href="/assets/files/ojp3/HISTORIA CEN OD DNIA 11.09.2025 DO DNIA 12.10.2025_OSIEDLE JANOWO PARK III.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 11.09.2025 DO DNIA 12.10.2025
                  </span>
                </a>
              </p>

              <p><strong>Prospekt informacyjny</strong></p>
              <p>
                <a href="/assets/files/ojp3/2025.09.11 - Osiedle Janowo Park III - Zad. inw. A - Prospekt informacyjny.pdf" target="_blank" rel="nofollow">
                  2025.09.11 - Osiedle Janowo Park III - Zad. inw. A
                </a>
              </p>
              <p>
                <a href="/assets/files/ojp3/2025.09.11 - Osiedle Janowo Park III - Zad. inw. B-C - Prospekt informacyjny.pdf" target="_blank" rel="nofollow">
                  2025.09.11 - Osiedle Janowo Park III - Zad. inw. B-C
                </a>
              </p>
            </Col>
          </Row>

        </Container>
        <EstatePlan image={planImage} scrollDestination={scrollDestination} />
        <JanowoTwoVisual

          slides={[wiz_u6]}
          alt={`Janowo Park 3 Lokalizacja`}
        />
        <div  style={{ marginTop: "40px" }}></div>
        <OJP3Localization />


        <LogBuilding
          logs={logs}
          anchor={`/pl/oferta/osiedle-janowo-park-3/#diary`}
        />

        <EstateModalForm
          title={"Osiedle Janowo Park III"}
          estate={"Osiedle Janowo Park III"}
          buttonText={"Zapytaj o ofertę"}
        >
          <p style={{ textAlign: "center" }}>
            Nowoczesne podejście do architektury, wygodna lokalizacja oraz
            bliskość malowniczego Parku "Błonia Janowskie" sprawiają, że Osiedle
            Janowo Park III jest inwestycją, o którą nasi klienci pytają
            najczęściej!
          </p>
        </EstateModalForm>

        <EstateDisclaimer />
        <Modal />
      </Layout>
    </>
  )
}

export default Janowo3
